import React, { memo, useState } from 'react';

import ChartStockForeignBS from '../chart/chartStockForeignBS';

import PerfectScrollbar from 'react-perfect-scrollbar';
import { numberFormat } from 'utils';
import ChartStockNetBuy from '../chart/chartStockNetBuy';

function PanelStockSummary(props) {
  const [tabNNActive, setTabNNActive] = useState('10-phien');
  const {stockDetail, symActive, algoSChart} = props

  // log(stockDetail)

  return (
    <PerfectScrollbar
      className="mt-2"
      style={{ height: 'calc(100vh - 180px)', marginRight: '-12px' }}
    >
      <div className="w-100" style={{ paddingRight: '12px', marginTop: '12px' }}>
        <p
          className="txt-content font-weight-bold fz-12 mb-2"
          style={{ lineHeight: '14px' }}
        >
          Giao dịch NĐTNN
        </p>
        <div
          className="d-grid"
          style={{ gridTemplateColumns: 'auto auto auto', gap: '10px' }}
        >
          <span className="txt-disabled fz-12">KL Mua</span>
          <span className="txt-disabled fz-12">KL Bán</span>
          <span className="txt-disabled fz-12">KL Mua ròng</span>
          <span className="color-up fz-12">{numberFormat(stockDetail.FGBuyQuantity)}</span>
          <span className="color-down fz-12">{numberFormat(stockDetail.FGSellQuantity)}</span>
          <span className={`color-${stockDetail.FGNetQuantity > 0 ? 'up' : 'down'} fz-12`}>{numberFormat(stockDetail.FGNetQuantity)}</span>
          <span className="txt-disabled fz-12">GT Mua</span>
          <span className="txt-disabled fz-12">GT Bán</span>
          <span className="txt-disabled fz-12">GT Mua ròng</span>
          <span className="color-up fz-12">{numberFormat(stockDetail.FGBuyValue, 2, '0')} Tỷ</span>
          <span className="color-down fz-12">{numberFormat(stockDetail.FGSellValue, 2, '0')} Tỷ</span>
          <span className={`color-${stockDetail.FGNetValue > 0 ? 'up' : 'down'} fz-12`}>{numberFormat(stockDetail.FGNetValue, 2, '0')} Tỷ</span>
        </div>

        <div className="my-2 d-flex align-items-center">
          <span className="mr-auto txt-disabled fz-12">NN mua ròng</span>
          <div className="btn-gr-nn-muarong">
            <span
              onClick={() => setTabNNActive('Hom-Nay')}
              className={'fz-12 ' + (tabNNActive === 'Hom-Nay' ? 'active' : '')}
            >
              Hôm nay
            </span>
            <span
              onClick={() => setTabNNActive('10-phien')}
              className={
                'fz-12 ' + (tabNNActive === '10-phien' ? 'active' : '')
              }
            >
              10 phiên
            </span>
          </div>
        </div>
        {tabNNActive === '10-phien' && <ChartStockNetBuy symActive={stockDetail.CompanyID}/>}
        {tabNNActive === 'Hom-Nay' && <ChartStockForeignBS algoSChart={algoSChart} symActive={symActive} />}
        {/* {tabNNActive === '10-phien' && <ChartMuaBanRong />}
        {tabNNActive === 'Hom-Nay' && <ChartStockForeignBS topShow={topShow} />} */}
      </div>
    </PerfectScrollbar>
  );
}

export default memo(PanelStockSummary);
